module.exports = __webpack_public_path__ + "img/engagement-photo-7.4edbe866.jpg";